import React, { useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { showTimeByDateType, newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import {
  buildTopCountriesBarChartData,
  getPlayerCountryMetricValue,
} from '../../../_config/_utils';
import { FIRST_COLORS, SECOND_COLORS, THIRD_COLORS } from '@/pages/intelligence/utils/echartsConst';
import { getLocale } from 'umi';
const COLORLIST = [...FIRST_COLORS, ...SECOND_COLORS, ...THIRD_COLORS];
// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Line,
    isNodata,
    metric,
    titleNow,
    chartLoading,
    setChartLoading,
    countryLatestDate,
    tableData,
    dateType,
    startDate = '',
    endDate = '',
  } = props;

  // console.log('Visualis', props);
  const locale = getLocale();
  const cardRef = useRef<HTMLDivElement | null>(null);

  // 柱状图固定 Top 19 国家 + 1 个 Others
  const truncatedTableData = useMemo(() => {
    return buildTopCountriesBarChartData(tableData, metric);
  }, [tableData, metric]);

  const barNameList = useMemo(() => {
    // countries 分布：x 轴直接使用 market（后端可能返回国家名称而非 code）
    return truncatedTableData?.map((item: { market: any }) => item?.market) || [];
  }, [truncatedTableData]);

  const barSeriesData = useMemo(() => {
    return truncatedTableData?.map((item: any, i: number): any => ({
      type: 'bar',
      name: locale === 'zh-CN' ? item?.name_cn : item?.name,
      value: getPlayerCountryMetricValue(item, metric),
      market: item.market,
      date: showTimeByDateType(countryLatestDate, dateType?.toLocaleLowerCase()),
      itemStyle: {
        color: COLORLIST[i],
      },
      label: {
        show: true,
        position: 'top',
        color: '#444',
        distance: 4,
        fontSize: 12,
        formatter: (params: any) => `${newMathFormat(Number(params.value), true)}`,
      },
    }));
  }, [truncatedTableData, metric, locale]);
  // 获取柱状图hooks
  const { barOption } = useBarCharts({
    seriesData: barSeriesData,
    barOrPieData: barSeriesData,
    setChartLoading,
    titleNow,
    barNameList,
    // 固定类型：让 players_by_country / gamalytic__players_by_country 都走同一套“Countries share”柱状图逻辑
    topChartsType: 'steamSales—countries-players_by_country',
    cardWidth: cardRef?.current?.clientWidth,
    chartType,
    ifNoBarImg: false,
    ifNeedSourceImg: false,
    useMarketFilterApiKey: 'rpd',
    startDate,
    endDate,
  });

  return (
    <>
      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          chartLoading={chartLoading}
          barOption={barOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
